import React, { useEffect, useState } from "react";
import { CloudOff, RefreshCw } from "lucide-react";
import { getOfflineState, subscribeOffline } from "../lib/offline";

// Signal drops all the time here. Rather than an error, say plainly what they're looking at: the
// deals are whatever the phone kept from the last visit, so the prices may have moved on.
export const OfflineNote = () => {
  const [{ offline }, setState] = useState(getOfflineState);
  const [netDown, setNetDown] = useState(() => typeof navigator !== "undefined" && navigator.onLine === false);

  useEffect(() => subscribeOffline(setState), []);
  useEffect(() => {
    const down = () => setNetDown(true);
    const up = () => setNetDown(false);
    window.addEventListener("offline", down);
    window.addEventListener("online", up);
    return () => {
      window.removeEventListener("offline", down);
      window.removeEventListener("online", up);
    };
  }, []);

  if (!offline && !netDown) return null;

  return (
    <div
      role="status"
      data-testid="offline-note"
      className="flex flex-wrap items-center gap-3 rounded-2xl border border-amber-300/70 bg-amber-50 dark:bg-amber-500/10 dark:border-amber-500/30 px-4 py-3"
    >
      <CloudOff size={18} className="text-amber-700 dark:text-amber-400 shrink-0" />
      <p className="text-sm text-amber-900 dark:text-amber-200 min-w-0">
        <strong className="font-bold">You're offline.</strong>{" "}
        These are the deals from your last visit — prices and end times may have moved on. Anything
        new needs signal.
      </p>
      <button
        onClick={() => window.location.reload()}
        data-testid="offline-retry"
        className="ml-auto inline-flex items-center gap-1.5 text-xs font-bold text-amber-900 dark:text-amber-200 border border-amber-400/70 hover:bg-amber-100 dark:hover:bg-amber-500/20 rounded-full px-3 py-1.5 transition-colors"
      >
        <RefreshCw size={13} /> Try again
      </button>
    </div>
  );
};

export default OfflineNote;
